import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export type KeyPagesProps = { page: string };

export const keyPages: BaseKeyFunction<KeyPagesProps> = ({ page }) => [
  "pages",
  page,
];
